import axios from 'axios';
import { TokenManager } from './auth/token-manager';

// Minimal instance, config managed elsewhere
const apiBaseURL = process.env.NEXT_PUBLIC_API_BASE_URL || '/api';
const axiosInstance = axios.create({
  baseURL: apiBaseURL,
  // timeout, etc. can be set here
  withCredentials: true, // Force l'envoi des cookies de session pour chaque requête
});

// Add a request interceptor to inject Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = TokenManager.getAccessToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
      // Debug log in development
      if (process.env.NODE_ENV === 'development') {
        // Only log the first 10 chars of the token for security
        console.debug('[axiosInstance] Using token:', token.substring(0, 10) + '...');
      }
    }
    
    // Ajouter des logs détaillés pour le débogage
    console.log(`🔍 Requête sortante: ${config.method?.toUpperCase()} ${config.url}`);
    
    return config;
  },
  (error) => {
    console.error(`❌ Erreur de requête:`, error);
    return Promise.reject(error);
  }
);

// Add a response interceptor for better error handling
axiosInstance.interceptors.response.use(
  (response) => {
    // Log successful responses
    console.log(`✅ Réponse réussie: ${response.config.method?.toUpperCase()} ${response.config.url} [${response.status}]`);
    return response;
  },
  async (error) => {
    // Si l'erreur n'a pas de réponse, c'est probablement une erreur réseau
    if (!error.response) {
      console.error(`🔥 Erreur réseau lors de l'appel API: ${error.config?.method?.toUpperCase()} ${error.config?.url}`);
      console.error('Détails de l\'erreur:', error.message);
      return Promise.reject(error);
    }

    // Extraire les informations de la requête pour le logging
    const { config, response } = error;
    const url = config?.url || 'inconnu';
    const method = config?.method?.toUpperCase() || 'GET';
    const status = response?.status || 0;
    
    console.error(`❌ Erreur API: ${method} ${url} [${status}]`);
    
    if (response.data) {
      console.error('Détails de l\'erreur:', response.data);
    }

    // Gestion spécifique pour les erreurs 403 (forbidden) post-onboarding
    if (status === 403 && 
        (url.includes('/dashboard') || url.includes('/tenants') || url.includes('/organizations'))) {
      console.warn('🚨 Accès refusé (403) détecté pour une route protégée après onboarding');
      console.warn('Tentative de récupération du contexte d\'authentification...');
      
      // Mise à jour explicite du dernier temps d'activité
      TokenManager.updateLastActivity();
      
      // Synchronisation forcée des tokens
      TokenManager.synchronizeTokens();
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
